import React, { useEffect, useState } from "react";
import { useFormikContext, Formik, Form, Field, useField } from "formik";

import {
  Grid,
  Card,
  Box,
  Stack,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  obtenerFlujo,
  obtenerMatrizPreevaluacion,
} from "../services/creditoServices";

import "../styles/main.css";
import { DataGrid } from "@mui/x-data-grid";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";
import {
  SCSTableData,
  SCSTableDataCell,
  SCSTableDataRow,
} from "app/modules/common/components/TableData/SCSTableData";

import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import CancelOutlined from "@mui/icons-material/CancelOutlined";

const MatrizPreevaluacion = ({ idCliente, cliente, cupoPreap, solic }) => {
  const [solicitud, setSolicitud] = useState(solic);

  const itemsMatriz = new Map();
  itemsMatriz.set("fechaPreevaluacion", "Fecha de Preevaluacion");
  itemsMatriz.set("dactilar", "Codigo Dactilar");
  itemsMatriz.set("celularSi", "Celular en Sistema SCS");
  itemsMatriz.set("emailSi", "Email en Sistema SCS");
  itemsMatriz.set("permanenciaLab", "Permanencia Laboral");
  itemsMatriz.set("flujoFinal", "Flujo recomendado Preevaluacion");
  itemsMatriz.set("perfil", "Perfil del Cliente");
  itemsMatriz.set("propio", "Cumple Score Propio");
  itemsMatriz.set("buro", "Cumple Score Buró");
  itemsMatriz.set("matrizRiesgo", "Cumple Matriz de Riesgo");
  itemsMatriz.set("pagJudicial", "Cumple con paginas judiciales");
  itemsMatriz.set("identidad", "Se valida identidad");
  itemsMatriz.set("laboral", "Cumple validacion laboral");
  itemsMatriz.set("nacionalidad", "Cumple validacion de nacionalidad");
  itemsMatriz.set("edadMinima", "Cumple edad minima");
  itemsMatriz.set("ingresos", "Cumple validacion de ingresos");
  itemsMatriz.set("bloqueos", "Cumple validacion de bloqueos");
  itemsMatriz.set("colaborador", "Cumple validacion de colaborador");

  const [infoPreevaluacion, setInfoPreevaluacion] = useState([]);

  useEffect(() => {
    // console.log(solicitud);

    getDataPreevaluacion();
  }, []);

  const getDataPreevaluacion = async () => {
    const respFlujo = await obtenerFlujo(solic.idFlujo);
    //console.log(respFlujo);
    const idGrupo = respFlujo.data.idGrupo;
    try {
      const respPreevaluacion = await obtenerMatrizPreevaluacion(
        solicitud.identificacion,
        idGrupo
      );
      if (respPreevaluacion.state) {
        console.log(respPreevaluacion.data);
        setInfoPreevaluacion(Object.entries(respPreevaluacion.data));
      } else {
        console.log(respPreevaluacion.message);
      }
    } catch (_errors) {
      console.log(_errors);
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "";
    }
    const fechaModificada = fecha.split("T");
    return fechaModificada[0];
  };

  const renderValores = (value) => {
    if (value === true) {
      return <CheckCircleOutline color="success" />;
    } else if (value === false) {
      return <CancelOutlined color="error" />;
    } else if (typeof value === "string") {
      return formatearFecha(value);
    }
    // Caso por defecto (opcional, para valores nulos/indefinidos)
    return value;
  };

  const columnsData = [
    { id: 1, name: "ITEM PREEVALUACION" },
    { id: 2, name: "DETALLE" },
  ];

  return (
    <>
      <SCSAccordion tituloCabecera="Datos de Preevaluacion de Cliente">
        <div className="accordion-container">
          <Grid container justifyContent="center" rowSpacing={3}>
            <Grid item lg={12}>
              <Card style={{ justifyContent: "center" }}>
                <SCSTableData columnsData={columnsData}>
                  {infoPreevaluacion.map(([rowKey, rowValue]) => (
                    <SCSTableDataRow key={rowKey}>
                      <SCSTableDataCell align="center">
                        {itemsMatriz.get(rowKey)}
                      </SCSTableDataCell>
                      <SCSTableDataCell align="center">
                        {renderValores(rowValue)}
                      </SCSTableDataCell>
                    </SCSTableDataRow>
                  ))}
                </SCSTableData>
              </Card>
            </Grid>
          </Grid>
        </div>
      </SCSAccordion>
    </>
  );
};

export default MatrizPreevaluacion;
